<template>
  <v-container fluid>
    <v-row justify="center" class="px-5">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mt-16" icon v-bind="attrs" v-on="on" @click="$router.go(-1)">
                <v-icon x-large color="white">{{ 'mdi-arrow-left-circle' }}</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('back') }}</span>
          </v-tooltip>
      <v-col cols="12" md="7">
        <v-card class="mx-auto my-16" max-width="900">
          <v-card-text class="_grey--text subtitle-1">
            <v-row class="ma-5">
              <v-col cols="auto" sm="3">
                <v-img max-height="180" width="180" contain :src="app.icon"></v-img>
              </v-col>
              <v-col cols="12" sm="9">
                <v-row class="_grey--text text-h5 font-weight-black">{{ app.name }}</v-row>
                <v-row class="_blue--text subtitle-2" justify="space-around">
                  <v-col>
                    <template v-for="item in categoryType">
                      <div :key="item">
                        <a class="_blue--text" @click="categoryClick(item)">{{ categoryName(item) }}</a>
                      </div>
                    </template>
                    <br /><br />
                    <a class="_blue--text" @click="addWishClick()">
                      <v-icon color="_blue">{{ wishIcon }}</v-icon>
                      {{ $t('addToWishlist') }}
                    </a>
                    <br />
                    <!-- 新增分享功能---網址複製到剪貼簿  by CHEN JING SIAN 2022-01-22-->
                    <a class="_blue--text" @click="shareCopyClick(app.name)">
                      <!-- <a class="_blue--text" v-on:click="shareCopyClick()"> -->
                      <v-icon color="_blue">mdi-share-variant</v-icon>
                      {{ $t('shareCopy') }}
                    </a>
                  </v-col>
                  <v-col align="end">
                    <v-row class="_grey--text">
                      <v-col>
                        <v-rating :value="app.rating" color="_grey" background-color="_grey" dense half-increments readonly size="16"></v-rating>
                        <span>{{ installCount }}</span
                        ><v-icon>mdi-account</v-icon> <br /><br /><br /><br />
                        <v-btn class="mr-2 _blue _light_grey--text" :disabled="btnManualDisable" @click="manualClick()">{{ $t('manual') }}</v-btn>
                        <v-tooltip bottom :disabled="!btnInstallDisable">
                          <template v-slot:activator="{ on }">
                            <div v-on="on" class="d-inline-block">
                              <v-btn class="_blue _light_grey--text" :disabled="btnInstallDisable" @click="dialogClick()">
                                {{ $t('install') }}
                              </v-btn>
                            </div>
                          </template>
                          <span>{{ $t('hintInstall') }}</span>
                        </v-tooltip>
                        <div v-if="!discount.exist">{{ $t('charge') + '：NT$' + priceSign(app.price) + '/' + $t(chargeType) }}</div>
                        <template v-else>
                          <div class="text-decoration-line-through">{{ $t('charge') + '：NT$' + priceSign(app.price) + '/' + $t(chargeType) }}</div>
                          <div class="red--text">{{ discountPeriod }}</div>
                          <div class="red--text">{{ $t('discount') + '：NT$' + priceSign(discount.price) + '/' + $t(chargeType) }}</div>
                        </template>
                        <div>{{ $t('size') + '：' + appSize }}</div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="mx-5" v-if="isShowWriteComment">
              <v-card-text class="subtitle-1">
                <div class="font-weight-black">{{ $t('rateApp') }}</div>
                <v-row class="my-2 px-3" @click="commentEdit({})">
                  <a><v-rating background-color="_blue" dense half-increments readonly size="20"></v-rating></a>
                  <a class="_blue--text">{{ $t('writeComment') }}</a>
                </v-row>
              </v-card-text>
            </v-row>
            <v-row class="mx-5">
              <CarouselBox
                :items="carouselItems"
                :showArrows="true"
                :isCycle="false"
                imgMaxHeight="400"
                :hideDelimiter="true"
                @action="crouselAction"
              />
            </v-row>
            <v-row class="mx-5">
              <v-card-text class="subtitle-1">
                <template v-if="app.chargeTypeDescription && app.chargeTypeDescription !== 'pseudo'">
                  <div class="font-weight-black">{{ $t('chargeMethod') }}</div>
                  <div>{{ app.chargeTypeDescription }}</div>
                  <div>{{ $t('minCharge') + '：NT$' + app.minFee }}</div>
                  <br />
                </template>
                <label class="font-weight-black" for="introLabel">{{ $t('introduction') }}</label>
                <v-textarea class="my-textarea ma-0 pa-0" v-model="app.description" rows="1" id="introLabel" flat auto-grow disabled />
                <label class="font-weight-black" for="specLabel">{{ $t('specification') }}</label>
                <v-textarea class="my-textarea ma-0 pa-0" v-model="app.specification" rows="1" id="specLabel" flat auto-grow disabled />
                <div class="font-weight-black">{{ $t('requirement') }}</div>
                <div v-if="app.requireSensor && app.requireSensor !== ''">{{ $t('requireSensor') + '：' + app.requireSensor }}</div>
                <div v-else>{{ $t('requireSensor') + '：' + $t('unrequirement') }}</div>
                <div v-if="app.requireIndustry && app.requireIndustry !== ''">{{ $t('requireIndustry') + '：' + requireIndustryName() }}</div>
                <div v-else>{{ $t('requireIndustry') + '：' + $t('unrequirement') }}</div>
                <div v-if="app.requireSmb && app.requireSmb !== ''">{{ $t('requireSmb') + '：' + app.requireSmb }}</div>
                <div v-else>{{ $t('requireSmb') + '：' + $t('unrequirement') }}</div>
                <div v-if="app.isRequireNet">{{ $t('requireNet') + '：' + $t('yesrequirement') }}</div>
                <div v-else>{{ $t('requireNet') + '：' + $t('unrequirement') }}</div>
                <br v-if="isShowScore" />
                <v-divider v-if="isShowScore"></v-divider>
              </v-card-text>
            </v-row>
            <v-row class="mx-5">
              <v-card-text class="subtitle-1" v-if="isShowScore">
                <div class="font-weight-black">{{ $t('comment') }}</div>
                <Score :data="score" />
                <template v-for="item in showComment">
                  <Comment
                    :key="item.id"
                    :data="item"
                    :options="commentOptions(item)"
                    @edit="commentEdit(item)"
                    @helpful="commentUpdateHelpful(item)"
                    @response="commentResponse(item)"
                  />
                </template>
                <v-col v-if="isShowAllComment" align="center" @click="commentReadAll({})">
                  <a class="_blue--text">{{ $t('readAllComment') }}</a>
                </v-col>
              </v-card-text>
              <v-dialog v-model="isEditComment" max-width="705">
                <EditComment :data="editComment" @cancel="isEditComment = false" @submit="commentSubmit()" />
              </v-dialog>
              <v-dialog v-model="isResponseComment" max-width="705">
                <EditComment :data="editComment.response" option="response" @cancel="isResponseComment = false" @submit="commentSubmit()" />
              </v-dialog>
            </v-row>
            <v-row class="mx-5">
              <v-card-text class="subtitle-1">
                <v-divider class="mb-5"></v-divider>
                <div class="font-weight-black">{{ $t('otherInfo') }}</div>
                <v-row>
                  <v-col cols="12" sm="4">
                    <div class="font-weight-black">{{ $t('updateDate') }}</div>
                    <div>{{ appUpdateDate }}</div>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <div class="font-weight-black">{{ $t('installCount') }}</div>
                    <div>{{ installCount }}</div>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <div class="font-weight-black">{{ $t('developer') }}</div>
                    <div>{{ developer.chief + ' ' + developer.phoneNo }}</div>
                    <div>{{ developer.email }}</div>
                    <div>{{ developer.addr }}</div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-row>
          </v-card-text>
        </v-card>
        <v-row justify="center" class="mb-16">
          <v-btn class="_blue _light_grey--text" @click="$router.go(-1)">{{ $t('back') }}</v-btn>
        </v-row>
      </v-col>
      <v-col cols="12" md="auto" class="my-16">
        <v-card class="transparent">
          <v-card-text class="my-8">
            <v-row justify="space-between">
              <span class="_light_grey--text text-h5 font-weight-black">{{ $t('similarContent') }}</span>
              <v-btn class="_blue _light_grey--text" @click="seeMoreClick('similarContent')">{{ $t('seeMore') }}</v-btn>
            </v-row>
          </v-card-text>
          <template v-for="item in similarList.slice(0, 5)">
            <CardH class="mb-8" :data="item" :key="item.name" @click="cardClick(item.name)" />
          </template>
          <v-overlay :value="hasCarousel" @click.native="hasCarousel = false">
            <CarouselBox
              :items="carouselItems"
              :showArrows="true"
              :hideDelimiter="true"
              :isCycle="false"
              :isVideo="true"
              :width="width"
              :model="carouselIndex"
            />
          </v-overlay>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="isDialog" persistent max-width="300">
      <v-card class="mx-auto">
        <v-card-text class="subtitle-1">
          <br />
          <v-icon large>{{ 'mdi-help-box' }}</v-icon>
          {{ $t('dialogSure', [$t('install')]) }}
          <div class="mt-5 font-weight-black">{{ $t('requirement') }}</div>
          <div v-if="app.requireSensor && app.requireSensor !== ''">{{ $t('requireSensor') + '：' + app.requireSensor }}</div>
          <div v-else>{{ $t('requireSensor') + '：' + $t('unrequirement') }}</div>
          <div v-if="app.requireIndustry && app.requireIndustry !== ''">{{ $t('requireIndustry') + '：' + requireIndustryName() }}</div>
          <div v-else>{{ $t('requireIndustry') + '：' + $t('unrequirement') }}</div>
          <div v-if="app.requireSmb && app.requireSmb !== ''">{{ $t('requireSmb') + '：' + app.requireSmb }}</div>
          <div v-else>{{ $t('requireSmb') + '：' + $t('unrequirement') }}</div>
          <div v-if="app.isRequireNet">{{ $t('requireNet') + '：' + $t('yesrequirement') }}</div>
          <div v-else>{{ $t('requireNet') + '：' + $t('unrequirement') }}</div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="_blue" outlined text @click="isDialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="_blue" class="white--text" @click="installClick()">{{ $t('ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CarouselBox from '@/components/CarouselBox.vue';
import Db from '@/api/awsDb';
import File from '@/api/file';
import S3 from '@/api/awsS3';
import CommVar from '@/method/commVar';
import Score from '../components/Score.vue';
import Comment from '../components/Comment.vue';
import EditComment from '../components/EditComment.vue';
import CardH from '../components/CardH.vue';
import WebSocket from '../store/webSocket';
import Product from '../store/product';

export default {
  name: 'CardDetail',
  props: {
    productName: { type: String, require: true },
  },
  components: {
    CarouselBox,
    Score,
    Comment,
    EditComment,
    CardH,
  },
  data: () => ({
    appName: '',
    app: {},
    appSize: '',
    installCount: 0,
    categoryType: ['publishers', 'industrys', 'types', 'runtimeEnvironment'],
    hasCarousel: false,
    carouselIndex: 0,
    logParam: {},
    score: {},
    isShowScore: true,
    isShowWriteComment: false,
    isShowAllComment: false,
    commentList: [],
    showComment: [],
    editComment: {},
    isEditComment: false,
    isResponseComment: false,
    completeLogin: false,
    isDialog: false,
    discount: {},
    recommendList: [],
  }),
  computed: {
    ...mapState('authenticate', ['isSignIn', 'userAttribute']),
    ...mapState('dbTable', ['filterList', 'filterSubject', 'filterParams', 'customList']),
    ...mapGetters('dbTable', [
      'isLoadCategory',
      'productList',
      'getIndustryById',
      'getPublisherById',
      'getTypeById',
      'getEnvironmentById',
      'getChiefById',
      'generalIndustryId',
      'permissionId',
    ]),
    ...mapGetters('locale', ['locale']),
    btnManualDisable() {
      return !this.isSignIn || !this.app.docSingle;
    },
    btnInstallDisable() {
      return !this.isSignIn || !this.app.firmware || !WebSocket.isConnect() || !localStorage.getItem('deviceId') || this.userAttribute.group === 'pending'; // || !WebSocket.isInstallRuntime() // [runtime]
    },
    wishIcon() {
      if (!Object.prototype.hasOwnProperty.call(this.userAttribute, 'wishApp')) return 'mdi-bookmark-plus-outline';
      return this.userAttribute.wishApp.findIndex((x) => x === this.app.id) === -1 ? 'mdi-bookmark-plus-outline' : 'mdi-bookmark-plus';
    },
    carouselItems() {
      const ary = [];
      for (let i = 0; i < 3; i += 1) {
        if (this.app[`urls${i}`]) {
          ary.push({ src: this.app[`urls${i}`] });
        }
      }
      if (this.app.videoUrl) ary.push({ url: `${this.app.videoUrl.replace('watch?v=', 'embed/')}?rel=0&autoplay=1` });
      return ary;
    },
    similarList() {
      return this.recommendList.length === 0 ? this.productList.filter((item) => item.publishers === this.app.publishers) : this.recommendList;
    },
    isNoRequire() {
      if (this.app.requireSensor && this.app.requireSensor !== '') return false;
      if (this.app.requireIndustry && this.app.requireIndustry !== '') return false;
      if (this.app.requireSmb && this.app.requireSmb !== '') return false;
      if (this.app.isRequireNet) return false;
      return true;
    },
    appUpdateDate() {
      if (!this.app.updateTime) return '';
      return new Date(this.app.updateTime).toLocaleDateString();
    },
    developer() {
      if (!this.isLoadCategory || !Object.keys(this.app).length) {
        return {
          chief: '', phoneNo: '', email: '', addr: '',
        };
      }
      if (!this.app.chiefs) {
        return {
          chief: '', phoneNo: '', email: '', addr: '',
        };
      }
      return this.getChiefById(this.app.chiefs);
    },
    isManager() {
      return Object.keys(this.userAttribute.policy).findIndex((x) => x === this.permissionId('customerHandling')) !== -1;
    },
    chargeType() {
      switch (this.app.chargeTypeId) {
        case '1':
          return 'month';
        case '2':
          return 'frequency';
        case '3':
          return 'hour';
        default:
        case '4':
          return 'buyout';
      }
    },
    width() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '300';
        case 'sm':
          return '600';
        case 'md':
          return '1200';
        default:
        case 'lg':
          return '1500';
      }
    },
    discountPeriod() {
      return Product.discountPeriod();
    },
  },
  created() {
    if (Object.keys(this.$route.query).length) {
      this.appName = this.$route.query.name;
    } else if (this.productName) {
      this.appName = this.productName;
      window.sessionStorage.setItem('appName', this.appName);
    } else {
      this.appName = window.sessionStorage.getItem('appName');
    }
    this.loadApp(this.appName);
  },
  destroyed() {
    this.operationUpdate();
  },
  methods: {
    commentOptions(item) {
      const ary = [];
      ary.push('helpless');
      if (!this.isSignIn) return ary;
      if (item.email === this.userAttribute.email) ary.push('edit');
      // if (this.developer.email === this.userAttribute.email) ary.push('response');
      if (this.isManager) ary.push('response');
      return ary;
    },
    commentEdit(item) {
      if (JSON.stringify(item) === '{}') {
        if (Object.prototype.hasOwnProperty.call(this.userAttribute, 'avatar') && this.userAttribute.avatar.type === 'image') {
          this.editComment = { userName: this.userAttribute.name, avatar: this.userAttribute.avatar.path };
        } else {
          this.editComment = { userName: this.userAttribute.name };
        }
      } else {
        this.editComment = { ...item };
      }
      this.isEditComment = true;
    },
    commentResponse(item) {
      this.isResponseComment = true;
      this.editComment = { ...item };
      if (!Object.prototype.hasOwnProperty.call(item, 'response')) {
        this.editComment.response = { userName: this.userAttribute.name };
      }
    },
    commentUpdateHelpful(item) {
      Db.update('comment', 'id', { id: item.id, helpful: item.helpful });
    },
    commentSubmit() {
      if (this.isEditComment) {
        this.isEditComment = false;
        if (!Object.prototype.hasOwnProperty.call(this.editComment, 'id')) {
          this.editComment.id = CommVar.randomId();
          this.editComment.appId = this.app.id;
          this.editComment.email = this.userAttribute.email;
          this.editComment.helpful = 0;
        }
        this.editComment.updateTime = new Date().getTime();
      } else {
        this.isResponseComment = false;
        this.editComment.response.updateTime = new Date().getTime();
      }
      Db.create('comment', this.editComment).then(() => {
        this.commentUpdate();
      });
    },
    commentUpdate() {
      this.isShowScore = false;
      Db.scan('comment', { appId: this.app.id }).then((result) => {
        if (result.length > 0) {
          this.isShowScore = true;
          this.commentList = result.sort((a, b) => b.updateTime - a.updateTime);
          let totalScore = 0;
          this.score.chartData = [0, 0, 0, 0, 0]; // 5, 4, 3, 2, 1
          this.commentList.forEach((val) => {
            this.score.chartData[this.score.chartData.length - val.rating] += 1;
            totalScore += val.rating;
          });
          this.score.total = this.commentList.length;
          this.score.rating = Math.round((totalScore / this.score.total) * 100) / 100;
          this.isShowAllComment = this.commentList.length > 4;
          if (this.isShowAllComment) this.showComment = this.commentList.slice(0, 4);
          else this.showComment = [...this.commentList];
          this.app.rating = this.score.rating;
          Db.update('product', 'name', { name: this.app.name, rating: this.app.rating });
        }
      });
    },
    commentReadAll() {
      this.isShowAllComment = false;
      this.showComment = [...this.commentList];
    },
    requireIndustryName() {
      if (!this.isLoadCategory || !Object.keys(this.app).length) return '';
      return this.getIndustryById(this.app.requireIndustry).name;
    },
    categoryName(category) {
      if (!this.isLoadCategory || !Object.keys(this.app).length) return '';
      switch (category) {
        default:
          return '';
        case 'publishers':
          return this.getPublisherById(this.app.publishers).name;
        case 'industrys':
          return this.getIndustryById(this.app.industrys).name;
        case 'types':
          return this.getTypeById(this.app.types).name;
        case 'runtimeEnvironment':
          return this.getEnvironmentById(this.app.runtimeEnvironment).name;
      }
    },
    operationLog() {
      // if (!this.isSignIn || this.userAttribute.email === undefined) return;
      const params = {};
      params.id = CommVar.randomId();
      params.createTime = new Date().getTime();
      params.email = this.isSignIn ? this.userAttribute.email : '';
      params.log = { app: this.app.id, stayTime: 0 };
      params.sessionId = window.sessionStorage.getItem('id');
      Db.create('operation', params);
      this.logParam = params;
    },
    operationUpdate() {
      // if (!this.isSignIn || this.userAttribute.email === undefined) return;
      if (!Object.prototype.hasOwnProperty.call(this.logParam, 'log')) return;
      if (!Object.prototype.hasOwnProperty.call(this.logParam.log, 'stayTime')) return;
      this.logParam.log.stayTime = new Date().getTime() - this.logParam.createTime;
      Db.update('operation', 'id', this.logParam);
    },
    installLog() {
      const params = {};
      params.id = CommVar.randomId();
      params.createTime = new Date().getTime();
      if (this.cognitoUser !== null) {
        params.email = this.userAttribute.email;
      }
      params.appId = this.app.id;
      params.deviceId = localStorage.getItem('deviceId');
      Db.create('install', params);
      const data = {
        deviceId: params.deviceId,
        appName: this.app.name,
        appId: params.appId,
        userId: params.email,
      };
      if (this.app.chargeTypeId === '1') {
        // 按月
        data.type = 'subscription';
        data.year = new Date().getFullYear();
        data.month = new Date().getMonth() + 1;
        File.api('https://manager.imacloud.com.tw:8443/dw/metering/subscription/raw', 'POST', data);
      } else if (this.app.chargeTypeId === '4') {
        // 買斷
        data.type = 'buyout';
        File.api('https://manager.imacloud.com.tw:8443/dw/metering/buyout/raw', 'POST', data);
      }
    },
    crouselAction(index) {
      this.hasCarousel = true;
      this.carouselIndex = index;
    },
    addWishClick() {
      const ary = { ...this.userAttribute };
      if (!Object.prototype.hasOwnProperty.call(ary, 'wishApp')) ary.wishApp = [];
      const index = ary.wishApp.findIndex((e) => e === this.app.id);
      if (index === -1) {
        ary.wishApp.push(this.app.id);
      } else {
        ary.wishApp.splice(index, 1);
      }
      Db.update('user', 'email', ary);
      this.$store.commit('authenticate/setUserAttribute', ary);
    },
    shareCopyClick() {
      // alert(`https://portal.imacloud.com.tw/#/cardDetail?name=${tempUrl}`);
      // alert(`已將連結複製到剪貼簿`);
      this.$store.commit('notify/set', { type: 'success', msg: [this.$t('copyAlert')] });
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('value', window.location.href);
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
      }
      document.body.removeChild(input);
    },
    manualClick() {
      this.$store.commit('loading/start', { text: 'working' });
      File.download(this.app.docNameSingle, this.app.docSingle)
        .then(() => {
          this.$store.commit('loading/stop');
        })
        .catch((err) => {
          this.$store.commit('loading/stop');
          console.log(err);
        });
    },
    async dialogClick() {
      // [unpaid]
      const res = await File.api('https://cashflow.imacloud.com.tw/api/checkUserStatus', 'POST', { userList: [this.userAttribute.email] });
      console.log(res.data[0].status);
      if (res.data[0].status !== 'safe') {
        this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errAccountUnpaid')] });
        return;
      }
      // [merchantId]
      const shopInfo = this.getPublisherById(this.app.publishers);
      if (!Object.prototype.hasOwnProperty.call(shopInfo, 'merchantId')) {
        this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errMerchantId')] });
        return;
      }
      // console.log(shopInfo.merchantId);
      this.isDialog = true;
    },
    installClick() {
      this.isDialog = false;
      if (!WebSocket.isConnect()) {
        this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errServerDisconnect')] });
        return;
      }
      this.$store.commit('loading/start', { text: 'working' });
      // if (this.app.requireIndustry && this.app.requireIndustry !== '') {
      //   let retVal = 'ok';
      //   await fetch('https://localhost:44566/swagger/index.html')
      //     .then(() => {})
      //     .catch(() => {
      //       this.$store.commit('loading/stop');
      //       this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errIndustryDisconnect')] });
      //       retVal = 'fail';
      //     });
      //   if (retVal === 'fail') return;
      // }
      WebSocket.install(this.app)
        .then(() => {
          this.$store.commit('loading/stop');
          const params = {};
          if (this.cognitoUser !== null) {
            params.email = this.userAttribute.email;
          }
          params.appName = this.app.name;
          params.deviceId = localStorage.getItem('deviceId');
          params.deviceName = localStorage.getItem('deviceName');
          params.appId = this.app.id;
          Product.install(params).then((x) => {
            // console.log(x);
            this.$store.commit('authenticate/setUserAttribute', x.data);
            this.$store.commit('notify/set', { type: 'success', msg: [this.$t('install'), ' ', this.$t('success')] });
          });
          // this.installLog();
          // const ary = { ...this.userAttribute };
          // if (!Object.prototype.hasOwnProperty.call(ary, 'myApp')) ary.myApp = [];
          // ary.myApp.push(this.app.id);
          // ary.myApp = Array.from(new Set(ary.myApp));
          // Db.update('user', 'email', ary);
          // this.$store.commit('authenticate/setUserAttribute', ary);
          // this.$store.commit('notify/set', { type: 'success', msg: [this.$t('install'), ' ', this.$t('success')] });
        })
        .catch(() => {
          this.$store.commit('loading/stop');
          this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('install'), ' ', this.$t('fail')] });
        });
    },
    cardClick(productName) {
      this.operationUpdate();
      this.loadApp(productName);
    },
    seeMoreClick(subject) {
      this.$store.commit('dbTable/setFilterList', this.similarList);
      this.$store.commit('dbTable/setFilterSubject', this.$t(subject));
      this.$router.push({ name: 'filterList' });
    },
    industrysFilter(category, product) {
      return category === 'industrys' && product[category] === this.generalIndustryId(this.locale);
    },
    categoryClick(category) {
      if (!this.productList.length) return;
      this.$store.commit('dbTable/clearFilterParams');
      if (category === 'publishers') {
        const custom = this.customList.find((x) => x.id === this.app.publishers);
        this.customPage = custom === undefined ? 0 : custom.type;
      } else {
        this.customPage = 0;
      }
      const params = this.filterParams;
      params[category] = this.app[category];
      const list = this.productList.filter((item) => item[category] === this.app[category] || this.industrysFilter(category, item));
      this.$store.commit('dbTable/setFilterList', list);
      this.$store.commit('dbTable/setFilterSubject', this.categoryName(category));
      this.$store.commit('dbTable/setFilterParams', params);
      if (this.customPage !== 0) {
        this.$store.commit('dbTable/setFilterSubject', this.app.publishers);
        this.$router.push({ name: `custom${this.customPage}` });
      } else {
        this.$router.push({ name: 'filterList' });
      }
      window.history.replaceState(null, null, `#/?${category}=${this.app[category]}`);
    },
    priceSign(price) {
      return Number(price).toLocaleString();
    },
    loadApp(productName) {
      window.history.replaceState(null, null, `#/cardDetail?name=${productName}`);
      Db.read('product', 'name', productName)
        .then((res) => {
          if (!res) {
            this.$router.push({ name: 'Error' });
            return;
          }
          this.app = res;
          this.operationLog();
          this.commentUpdate();
          Db.scan('install', { appId: this.app.id }, ['email']).then((result) => {
            this.installCount = result.length;
            this.isShowWriteComment = result.filter((item) => item.email === this.userAttribute.email).length !== 0;
          });
          this.appSize = '';
          this.discount = Product.discountProc(this.app.discountPeriod, this.app.discount);
          let replaceStr = process.env.VUE_APP_S3_URL;
          let backetName = process.env.VUE_APP_S3_BUCKET;
          if (this.app.firmware.includes(process.env.VUE_APP_NIP_URL)) {
            replaceStr = process.env.VUE_APP_NIP_URL;
            backetName = process.env.VUE_APP_NIP_BUCKET;
          }
          const url = decodeURI(this.app.firmware).replace(replaceStr, '');
          S3.list(backetName, url).then((value) => {
            const size = value.Contents[0].Size;
            if (size > 1000000) {
              this.appSize = `${Math.round(size / 1000000)}M`;
            } else {
              this.appSize = `${Math.round(size / 1000)}K`;
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
      Db.read('recommendItem', 'name', productName).then((result) => {
        if (result.length === 0) this.recommendList = [];
        for (let i = 1; i < Object.keys(result).length; i += 1) {
          if (result[`R${i}`] !== '0') {
            const temp = this.productList.find((x) => x.name === result[`R${i}`]);
            if (temp !== undefined) this.recommendList.push(temp);
          }
        }
      });
    },
  },
};
</script>

<style>
.my-textarea textarea {
  color: #737373 !important;
}
.v-textarea > .v-input__control > .v-input__slot:before {
  border-style: none;
}
</style>
